import type { ResumoDoBalconista } from '../../vendas';

/**
 * Regras puras da tela do balconista (revisão 360, 26/09/2026):
 *   - D6: a META DA SEMANA que ele vê é a do CHEQUE (itens líquidos: bateu com o HOS, menos
 *     devolução e cancelamento). O lançado aparece só como "lançados", com o nome certo — antes a
 *     barra enchia com o lançado, a tela gritava "META BATIDA!" e o cheque vinha R$ 0.
 *   - U6: venda bloqueada (Giro) ou sistema em manutenção trava o formulário NO TOPO, antes de ele
 *     preencher tudo e só no fim ouvir "não".
 */

export interface MetaDaSemanaNaTela {
  readonly meta: number;
  /** Os que valem para a meta (o cheque conta estes). */
  readonly confirmados: number;
  /** Tudo o que ele lançou na semana (ainda sem conferir com o HOS). */
  readonly lancados: number;
  /** 0 a 100, pelos confirmados. */
  readonly pct: number;
  readonly faltam: number;
  readonly batida: boolean;
  /** "9 confirmados de 10 · 10 lançados" */
  readonly legenda: string;
}

type ResumoDaMeta = Pick<ResumoDoBalconista, 'metaSemanal' | 'itensSemana' | 'metaDoCheque'>;

export function metaDaSemana(r: ResumoDaMeta): MetaDaSemanaNaTela {
  const c = r.metaDoCheque;
  const meta = c.meta;
  const confirmados = c.confirmados;
  const lancados = r.itensSemana;
  const pct = meta > 0 ? Math.min(100, Math.floor((confirmados / meta) * 100)) : 100;
  return {
    meta,
    confirmados,
    lancados,
    pct,
    faltam: c.faltam,
    batida: c.batida,
    legenda: `${String(confirmados)} ${confirmados === 1 ? 'confirmado' : 'confirmados'} de ${String(meta)} · ${String(lancados)} ${lancados === 1 ? 'lançado' : 'lançados'}`,
  };
}

export interface BloqueioDaVenda {
  readonly titulo: string;
  readonly texto: string;
}

/** Por que ele NÃO pode registrar agora (null = pode). Manutenção vem antes do Giro. */
export function bloqueioDaVenda(
  r: Pick<ResumoDoBalconista, 'manutencao' | 'bloqueioGiro'> | null,
): BloqueioDaVenda | null {
  if (!r) return null;
  if (r.manutencao)
    return { titulo: 'Sistema em manutenção: vendas pausadas agora.', texto: r.manutencao };
  if (r.bloqueioGiro)
    return {
      titulo: 'Suas vendas estão bloqueadas hoje.',
      texto: `${r.bloqueioGiro} Dúvida? Fale com o gestor.`,
    };
  return null;
}
